import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FormComponent } from './form.component';

import { LsFormCheckboxModule } from './ls-checkbox/ls-form-checkbox.module';
import { LsInputTextModule } from './ls-input-text/ls-input-text.module';
import { LsMultiSelectModule } from '../components/select/multi/ls-multi-select/ls-multi-select.module';
import { LsRowColumnSelectModule } from './ls-row-column-select/ls-row-column-select.module';
import { LsSingleSelectModule } from '../components/select/single/ls-single-select/ls-single-select.module';

import { SharedModule } from '../shared.module';
import { LsMultiCheckboxModule } from './ls-multi-checkbox/ls-multi-checkbox.module';

@NgModule({
  imports: [
    CommonModule,
    LsFormCheckboxModule,
    LsRowColumnSelectModule,
    LsMultiSelectModule,
    LsInputTextModule,
    LsSingleSelectModule,
    LsMultiCheckboxModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [FormComponent],
  exports: [FormComponent]
})
export class FormModule {}
